import { HINT_ICON } from '@xhs/yam-beer/cmp/constants/builtinIcon'

export default function getIcon(modifier: string): string[] {
  switch (modifier) {
    case 'info':
      return HINT_ICON.info
    case 'success':
      return HINT_ICON.success
    case 'warn':
      return HINT_ICON.warn
    case 'error':
      return HINT_ICON.error
    default:
      return HINT_ICON.info
  }
}
